import styled from "styled-components"
import {devices} from '../../../components/MediaQuerys/BreakpointsAndDevices'


const TextComponent = styled.p`
    font-family: ${props => props.fontFamily};
    font-size: ${props => props.fontSize};
    color: ${props => props.color};
    text-align: ${props => props.textAlign};
    word-break: keep-all;
    word-wrap: break-word;
    @media only screen and ${devices.mobileM} {
        /* background-color: rebeccapurple; */
        font-size: ${props => props.textSize};
        /* width: 310px;
        padding-left: ${props => props.paddingLeft}; */
    }


`
export const Text = (props)=>{
    return (
        <TextComponent 
            fontFamily={props.fontFamily}
            fontSize={props.fontSize}
            color={props.color}>
            {props.text}
        </TextComponent>
    )
}